<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">訂單管理 / 支付匯總數據</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px" visible>
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">品牌：</label>
                  <div class="col-md-4">
                    <select
                      name="queryBrandsCode"
                      class="form-control"
                      v-model="queryBrandsCode"
                    >
                    <option
                      v-for="x in selectListBrands"
                      v-bind:value="x.Code"
                      :key="x.Code"
                    >{{x.Text}}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <label class="control-label col-md-2 mt-2 text-right">訂餐日期：</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="sdate">
                  </div>
                  <label class="mt-2">至</label>
                  <div class="col-md-3">
                    <input type="date" class="form-control" v-model="edate">
                  </div>
                  <label class="mt-2">(日期區間可篩選30日)</label>
                </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right">門市：</label>
                <div class="col-md-4">
                  <multiselect v-model="store" :options="storelist" :multiple="false" :custom-label="nameWithLang" placeholder="請選擇" label="Name" track-by="Name" selectLabel="">
                    <span slot="noResult">查無資料</span>
                  </multiselect>
                </div>
                <label class="control-label col-md-2 mt-2 text-right">支付方式</label>
                <div class="col-md-4">
                  <select id="payment" name="payment" class="form-control" v-model="paymenttype">
                          <option v-bind:value="0" :key="0">全部</option>
                          <option v-for="x in paymenttypeList" v-bind:value="x.ID" :key="x.ID">{{x.Text}}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <label class="control-label col-md-2 mt-2 text-right"></label>
                <div class="col-md-3">
                </div>
                <div class="col-lg-6 mt-2 text-right">
                    <button type="button" class="btn btn-warning text-white" @click="getinformation(1)">查詢</button>
                </div>
              </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <fieldset>
            <legend>訂餐方式統計</legend>
            <table id="mytable" class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th width="17%" style="text-align: center;">訂餐方式</th>
                  <th width="12%" style="text-align: right;">訂單成立<br />(筆數)</th>
                  <th width="17%" style="text-align: right;">訂單成立<br />(金額)</th>
                  <th width="13%" style="text-align: right;">訂單未成立<br />(筆數)</th>
                  <th width="14%" style="text-align: right;">訂單未成立<br />(金額)</th>
                  <th width="12%" style="text-align: right;">退貨<br />(筆數)</th>
                  <th width="15%" style="text-align: right;">退貨<br />(金額)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(x) in typelist" :key="x.id">
                  <td style="text-align: left;">{{x.PaymentType}}</td>
                  <td>{{x.SuccessCount | formatThousand}}</td>
                  <td>{{x.SuccessSum | formatThousand}}</td>
                  <td>{{x.FailCount | formatThousand}}</td>
                  <td>{{x.FailSum | formatThousand}}</td>
                  <td>{{x.RefundCount | formatThousand}}</td>
                  <td>{{x.RefundSum | formatThousand}}</td>
                </tr>
              </tbody>
            </table>
            </fieldset>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <fieldset>
              <legend>支付方式統計</legend>
            <table id="mytable" class="table table-bordred table-striped">
              <thead>
                <tr>
                  <th width="17%" style="text-align: center;">支付方式</th>
                  <th width="12%" style="text-align: right;">訂單成立<br />(筆數)</th>
                  <th width="17%" style="text-align: right;">訂單成立<br />(金額)</th>
                  <th width="13%" style="text-align: right;">訂單未成立<br />(筆數)</th>
                  <th width="14%" style="text-align: right;">訂單未成立<br />(金額)</th>
                  <th width="12%" style="text-align: right;">退貨<br />(筆數)</th>
                  <th width="15%" style="text-align: right;">退貨<br />(金額)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(x) in orderlist" :key="x.id">
                  <td style="text-align: left;">{{x.PaymentType}}</td>
                  <td>{{x.SuccessCount | formatThousand}}</td>
                  <td>{{x.SuccessSum | formatThousand}}</td>
                  <td>{{x.FailCount | formatThousand}}</td>
                  <td>{{x.FailSum | formatThousand}}</td>
                  <td>{{x.RefundCount | formatThousand}}</td>
                  <td>{{x.RefundSum | formatThousand}}</td>
                </tr>
              </tbody>
            </table>
            </fieldset>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import miniToastr from 'mini-toastr'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import Multiselect from 'vue-multiselect'
miniToastr.init()
export default {
  components: {
    Multiselect
  },
  data () {
    return {
      storelist: [{ ID: 0, Code: '', Name: '' }],
      paymenttypeList: [], // 付款類型

      sdate: '',
      edate: '',
      payment: 0,
      store: '', // 門市
      paymenttype: '0',

      orderlist: [],
      typelist: [],
      queryBrandsCode: "MWD",
      selectListBrands: [], // 品牌下拉選單
    }
  },
  created () {
    this.setdate()
    this.getpost()
    this.querySelectListData()
    this.querySelectListBrands()
    this.FunctionPermission = getFunctionPermission('F33') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
  },
  methods: {
    onReady (instance) {
      this.instances.push(instance)
    },
    getinformation (currentPage) {
      if (this.store == null) {
        this.store = ''
      }
      if (this.sdate > this.edate) {
        miniToastr.error('請選擇正確的日期區間')
        return
      }
      if (this.ordercode === '' && (this.sdate === '' || this.edate === '')) {
        miniToastr.error('請輸入訂餐日期')
        return
      }
      // 計算天數
      var d1 = Date.parse(new Date(this.sdate))
      var d2 = Date.parse(new Date(this.edate))
      var day = parseInt((d2 - d1) / (1000 * 60 * 60 * 24))
      if (day > 30) {
        miniToastr.error('日期區間超過30日')
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/ordermanage/payment/list', {
        sdate: this.sdate,
        edate: this.edate,
        store: this.store.ID,
        paymenttype: Number(this.paymenttype),
        brandCode: this.queryBrandsCode,
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.orderlist = response.data.data
            this.typelist = response.data.data2
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },
    setdate () {
      var today = new Date()
      var todaymon = today.getMonth() + 1
      if (todaymon < 10) {
        todaymon = '0' + todaymon
      }

      var date = new Date()
      date.setMonth(date.getMonth())
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.sdate = year + '-' + todaymon + '-' + day
      this.edate = year + '-' + todaymon + '-' + day
    },
    getpost () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/getallstores/v1', {
        brandCode: this.queryBrandsCode
      })
        .then((response) => {
          if (response.data.result === '0000') {
            var plist = []
            var list = response.data.data
            list.forEach(function (arrRole, Index) {
              arrRole.Districts.forEach(function (arrRole1, Index1) {
                if (arrRole1.District === '全部區域') {
                  if (arrRole1.Stores) {
                    arrRole1.Stores.forEach(function (arrRole2, Index2) {
                      plist.push(arrRole2)
                    })
                  }
                }
              })
            })
            this.storelist = plist
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '資料讀取異常')
          this.$parent.Loading = false
        })
    },
    querySelectListData () {
      // 支付工具
      axios
        .post(API_URL + '/web/getpayment/v1', {
          status: 0
        })
        .then(response => {
          this.paymenttypeList = response.data.data
          this.$parent.Loading = false
        })
        .catch(error => {
          this.selectListPosType = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    }
  },
  watch: {
    queryBrandsCode(selectedBrandCode) {
      if (selectedBrandCode) {
      this.getpost()
      }
    }
  },
  filters: {
    formatFullDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var mon =
        d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
      var min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      return year + '/' + mon + '/' + day + ' ' + hour + ':' + min
    },
    formatThousand: function (value) {
      return value
        .toString()
        .replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function (all, pre, groupOf3Digital) {
          return pre + groupOf3Digital.replace(/\d{3}/g, ',$&')
        })
    }
  }
}
</script>
<style scoped>
  fieldset {
    padding: 8px 22px 18px;
    margin: 3px 12px 18px;
    border: 1px solid #519b39;
  }
  legend {
    padding: .2em;
    border: 0;
    width: auto;
    color: #519b39;
  }
  .box-shadow {
    box-shadow: 0px 0px 1px 1px #cfcfcf;
  }
  .font_text {
    font-size: 19px;
    margin: 6px 0 7px;
  }
  .icon_img {
    height: 100%;
    padding: 0;
    margin: -2px;
  }
  #mytable > tbody > tr > td {
    vertical-align: middle;
    text-align: right;
    height: 59px;
  }
  #mytable > tbody > tr > th {
    text-align: center;
    /* text-align: center; */
    height: 59px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/order/payment/List.vue